const currentEnv = process.env.REACT_APP_ENV || 'dev';
const version = 'v1';
const baseUrl = {
  prototype: 'https://l83jugg469.execute-api.ap-northeast-1.amazonaws.com/api',
  dev: 'https://lvy2sf2c14.execute-api.ap-northeast-1.amazonaws.com/api',
  stg: 'https://zbwlgj8rrh.execute-api.ap-northeast-1.amazonaws.com/api',
  prod: 'https://api.chino.cloud',
};

const ApiConstants = {
  BASE_URL: `${baseUrl[currentEnv]}/${version}/`,
  BASE_URL_V2: `${baseUrl[currentEnv]}/v2/`,
  LOGIN_URL: 'login',
  REFRESH_ACCESS_TOKEN_URL: 'refresh-token',
  PROFILE: 'profile',
  RESET_PASSWORD: 'reset_password',
  SET_NEW_PASSWORD: 'set_new_password',
  GATEWAYS: 'gateways',
  UNITS: 'devices',
  REALTIME_DATA: 'data',
  DASHBOARD: 'dashboard',
  DATA_VIEW: 'data/aggregated',
  LAST_DATA: 'data/latest',
  USERS_MANAGEMENT: 'users',
  GROUPS_MANAGEMENT: 'device_groups',
  LOGGERS_MANAGEMENT: 'loggers',
  ACTIVE_USERS: 'active_users',
  COMPANIES_MANAGEMENT: 'companies',
  STORES_MANAGEMENT: 'stores',
  DEPARTMENTS_MANAGEMENT: 'departments',
  LAST_SEQUENCE: 'last_sequence',
  GET_NEXT_SEQUENCE_VALUE: 'last_sequence/{:tableName}/next_sequence_value',
  UPDATE_USER_STATUS: 'update/user/status',
  RESEND_INVITATION_MAIL: 'resend/invitation',
  GET_DEVICE_CHANNELS: 'devices/{:deviceId}/channels',

  HEATMAP_MEASUREMENTS: 'heatmap-measurements',
  HEATMAP_MEASUREMENTS_ID: 'heatmap-measurements/{:measId}',

  HEATMAP_MEASUREMENTS_ACCESS: 'heatmap-measurements/{:measId}/access',
  HEATMAP_MEASUREMENTS_ACCESS_STATE:
    'heatmap-measurements/{:measId}/access/access-state',
  HEATMAP_MEASUREMENTS_CUSTOMER_ACCESS_LOGIN:
    'heatmap-measurements/access/login',
  HEATMAP_MEASUREMENTS_GENERATE_PRESIGNED_POST_URL:
    'heatmap-measurements/{:measId}/generate-presigned-post-url',

  HEATMAP_MEASUREMENT_AREAS: 'heatmap-measurements/{:measId}/areas',
  HEATMAP_MEASUREMENT_AREA_DETAILS:
    'heatmap-measurements/{:measId}/areas/{:areaNo}',
  HEATMAP_MEASUREMENT_AREA_MAP:
    'heatmap-measurements/{:measId}/areas/{:areaNo}/map',

  RECORDER: 'data/aggregated',

  BACKEND_VERSION: 'version',
};

export default ApiConstants;
